import DefaultMapper, { addCustomMethods } from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';

class BusinessContractRouteMapper extends DefaultMapper {

	mapResource() {
		return 'payment/businesscontracts/routes';
	}

	prepareCreate({ params, options, mappedResource }) {
		if (params.method) {
			options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${params.id}${addCustomMethods(params)}`;
			options.method = 'POST';
		} else {
			// Creation happens in the BusinessContractAdminController
			options.url = `${API_BASE_PATH_ADMIN}/payment/businesscontracts/${params.data.businessContractId}/routes`;
			options.method = 'POST';
			const filteredParams = Object.assign({}, params.data);
			delete filteredParams.businessContractId;
			options.body = JSON.stringify(filteredParams);
		}
	}

	prepareUpdate({ params, options }) {
		super.prepareUpdate(...arguments);
		const filteredParams = Object.assign({}, params.data);
		delete filteredParams.id;
		delete filteredParams.creationDateTime;
		delete filteredParams.businessContractId;
		options.body = JSON.stringify(filteredParams);
	}

}

export default BusinessContractRouteMapper;
